<template>
<div class="agent-login">
	<div class="body-text" v-html="bodyText"></div>
	
    <div class="col-12 left-column">
        <form class="loginform" @submit.prevent="onSubmit">

            <label for="Benutzername" class="login-label">
                <span>Ihr Name</span>
                <input class="login-input" v-model="benutzerName" id="Benutzername" name="Benutzername" type="text" value="" :readonly="agentHasAutoLogin" :disabled="agentHasAutoLogin">
            </label>

            <label for="Passwort" class="login-label">
                <span>Passwort</span>
                <input v-if="!agentHasAutoLogin" class="login-input password" v-model="passwort" id="Passwort" name="Passwort" type="password" value="">
                <button type="button" v-if="agentHasAutoLogin" class="login-button" @click="agentChange">Vertriebs-Account wechseln</button>
            </label>

            <label for="UserSAP" class="login-label">
                <span>SAP Nummer/Benutzername/One-Key ID</span>
                <input class="login-input valid@(errorClass)" id="UserSAP" name="UserSAP" type="text" v-model="sapNummer">
            </label>

            <div class="login-button-container" style="text-align:center;">
                <input v-if="!isLoading" class="login-button" type="submit" name="input-submit" id="input-submit" :value="submitButtonLabel" :disabled="!benutzerName || !sapNummer || (!passwort && !agentHasAutoLogin)"><br />
                <img v-if="isLoading" src="/src/images/ladeindikator-weiss.gif" />
            </div>
        </form>

        <div>
            <p class="textonly error" v-if="loginError">
                <strong>Die von Ihnen eingegebenen Login-Daten stimmen mit keinem der bei uns registrierten Konten überein. Bitte beachten Sie stets bei Ihrem Benutzernamen sowie Ihrem Passwort die Groß- und Kleinschreibung.</strong>
            </p>

            <p class="textonly error" v-if="agentError">
                <strong>Für diese SAP-Nummer bzw. Benutzernamen existiert kein Account.</strong>
            </p>
        </div>
    </div>
	<div class="col-12 right-column">
        <div class="multiple-accounts" v-if="multipleAccounts.length">
			<h3>Mehrere Accounts für SAP-Nummer {{originSapNummer}}</h3>
            <div class="account-group" v-if="doctorAccounts.length">
                <h3 class="account-group-title">Ärzte</h3>
                <table class="account-list">
                    <thead>
                        <tr>
                            <td>Benutzername</td>
                            <td>LetzterLogin</td>
                            <td class="list-action">Auswahl</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="line, ix in doctorAccounts" :key="`doctor-${ix}`">
                            <td>{{line.benutzerName}}</td>
                        	<td>{{line.lastLoginDate}}</td>
                            <td class="list-action" v-if="line.selected === true">
                                <div class="sap-selected">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
                                </div>
                            </td>
                            <td class="list-action" v-if="line.selected !== true">
                                <button type="button" class="btn-icon" @click="selectMultiAccount(line)">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM297 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l214.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L409 239c9.4 9.4 24.6 9.4 0 33.9L297 385z" /></svg>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="account-group" v-if="pharmacistAccounts.length">
                <h3 class="account-group-title">Apotheker</h3>
                <table class="account-list">
                    <thead>
                        <tr>
                            <td>Benutzername</td>
                            <td>LetzterLogin</td>
                            <td class="list-action">Auswahl</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="line, ix in pharmacistAccounts" :key="`pharmacist-${ix}`">
                            <td>{{line.benutzerName}}</td>
                        	<td>{{line.lastLoginDate}}</td>
                            <td class="list-action" v-if="line.selected === true">
                                <div class="sap-selected">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
                                </div>
                            </td>
                            <td class="list-action" v-if="line.selected !== true">
                                <button type="button" class="btn-icon" @click="selectMultiAccount(line)">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM297 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l214.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L409 239c9.4 9.4 24.6 9.4 0 33.9L297 385z" /></svg>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
		</div>
	</div>
	<div class="col-12 left-column">
		<p><a href="/zugangsdatenvergessen">Sie haben Ihre Zugangsdaten vergessen?</a></p>
	</div>
    <div class="col-12 right-column align-right" v-if="multipleAccounts.length">
		<button type="button" class="btn-icon" @click="toggleModal()">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" /></svg>
		</button>

		<!-- Dialog muss bei Klick auf Button showModal() gesetzt werden. Dann wird das Attribut "open gerendert" -->
		
		<dialog class="dialog-info" v-if="openModal" open>
			<div class="info-close">
				<button type="button" class="btn-icon" @click="openModal=false;">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" /></svg>
				</button>
			</div>
			<p>
				Bitte verwenden Sie statt der SAP-Nr. einen der angezeigten Accounts.
				Unsere vom System <strong>vorgeschlagene Empfehlung</strong> mit dem
				jüngsten Login wurde bereits automatisch eingesetzt. Über den Button 'Für Apotheke einloggen' können
				Sie sich nun direkt mit dem vorgeschlagenen Account einloggen.<br />
			</p>
		</dialog>
	</div>
</div>
</template>
	
<script lang="ts">
import {defineComponent} from "vue";
import axios from "axios";
import {extractAttrs} from "../../services/extract-attrs";
import { getCurrentQueryParameters } from "../../services/get-current-query-parameters";
import { setCookie } from "../../services/set-cookie";
import { getCookie } from "../../services/get-cookie";
import { getFormHashString } from "../../services/formSession";

interface MultiAccountModel {
    benutzerName: string;
    lastLoginDate: string;
    sapNummer: string;
    rolle: string;
    selected: boolean;
}

function toMultiAccountModel(raw: any): MultiAccountModel {
    return {
        benutzerName: raw.benutzerName ?? raw.BenutzerName ?? "",
        lastLoginDate: raw.lastLoginDate ?? raw.LastLoginDate ?? "",
        sapNummer: raw.sapNummer ?? raw.SapNummer ?? "",
        rolle: raw.rolle ?? raw.Rolle ?? "",
        selected: raw.selected ?? raw.Selected ?? false,
    };
}

function normalizeRole(value: string): string {
    return (value || "").trim().toLowerCase();
}

    const AgentLoginForm = defineComponent({
        name: "LoginForm",
        data() {
            return {
                bodyText: "",
                loginError: false,
                agentError: false,
                benutzerName: "",
                passwort: "",
                sapNummer: "",
                originSapNummer: "",
                multipleAccounts: [] as MultiAccountModel[],
                agentHasAutoLogin: false,
                openModal: false,
                isLoading: true,
                sessionId: ""
            }
        },
        props: {
            container: HTMLDivElement,
            agentHasAutoLogin: Boolean
        },
        async beforeMount() {
            this.agentHasAutoLogin = false;

            const attrs = extractAttrs(this.container!);
            const session = attrs["session"];
            const params = {
                form: "AgentLoginForm",
                sessionId: getFormHashString(session),
            }

            const vm = this;

            var response = await axios.post("/umbraco/aliud/login/getmodel", params);
            var data = response.data;

            vm.sessionId = data["sessionId"];

            vm.bodyText = data["bodyText"];
            var qpars = getCurrentQueryParameters();
            var bn = qpars["aun"];
            if (bn)
                vm.benutzerName = bn;
            var sn = qpars["asn"];
            if (sn)
                vm.sapNummer = sn;

            var agentCookie = getCookie("AgentAuthInfo");
            if (agentCookie !== "" && agentCookie !== null) {
                var agentAuthInfo = JSON.parse(decodeURIComponent(agentCookie));
                vm.benutzerName = agentAuthInfo.name;
                vm.agentHasAutoLogin = true;
            }

            vm.isLoading = false;

        },
        computed: {
            doctorAccounts(): MultiAccountModel[] {
                return this.multipleAccounts.filter((account) => normalizeRole(account.rolle) === "arzt");
            },
            pharmacistAccounts(): MultiAccountModel[] {
                return this.multipleAccounts.filter((account) => normalizeRole(account.rolle) === "apotheker");
            },
            selectedMultiAccount(): MultiAccountModel | null {
                return this.multipleAccounts.find((account) => account.selected) || this.multipleAccounts[0] || null;
            },
            submitButtonLabel(): string {
                const selectedRole = normalizeRole(this.selectedMultiAccount?.rolle || "");

                if (selectedRole === "arzt") {
                    return "Für Arzt anmelden";
                }

                if (selectedRole === "apotheker") {
                    return "Für Apotheke anmelden";
                }

                return "Für Apotheke/Arzt anmelden";
            }
        },
        methods: {
            agentChange() {
                var vm = this;
                vm.agentHasAutoLogin = false;
                setCookie("AgentAuthInfo", "", 0);
            },
            selectMultiAccount(line: MultiAccountModel) {
                var vm = this;

                vm.multipleAccounts.forEach(function (item: MultiAccountModel) {
                    if (item.benutzerName !== line.benutzerName) {
                        item.selected = false;
                    } else {
                        item.selected = true;
                    }
                });
                vm.sapNummer = line.benutzerName;
            },
            toggleModal() {

                this.openModal = !this.openModal;
                console.log(this.openModal);
            },
            async onSubmit() {
                var vm = this;
                this.isLoading = true;
                this.originSapNummer = this.sapNummer;
                var data = {
                    username: this.benutzerName,
                    password: this.passwort,
                    sessionId: getFormHashString(this.sessionId),
                    form: "AgentLoginForm",
                    userSAP: this.sapNummer,
                    isAutoLogin: this.agentHasAutoLogin
                };
                // Daten übertragen, Das ist die eigentliche Login-Validierung
                var response = await axios.post("/umbraco/aliud/login/postagentlogin", data);
                var responseData = response.data;
                vm.loginError = responseData.loginError;
                vm.agentError = responseData.agentError;
                vm.multipleAccounts = (responseData.multipleAccounts || []).map((item: any) => toMultiAccountModel(item));
                vm.sessionId = responseData.sessionId;

                if (vm.multipleAccounts.length) {
                    this.sapNummer = vm.multipleAccounts[0].benutzerName;
                }

                // Erfolgreich eingeloggt?
                if (!this.loginError && responseData.loginReturn) {
                    // Cookie für Auto-Login setzen
                    //setCookie("AgentAuthInfo", JSON.stringify(responseData.agentUserObj), 8);
                    window.location.href = responseData.loginReturn;

                } else {
                    this.isLoading = false;
                }

            }
        },
    });

export default AgentLoginForm;

</script>

